import React from "react";

const CheckboxField = ({
  label,
  checked,
  onChange,
  required = false,
  error,
}) => {
  return (
    <div className="flex flex-col items-start space-y-1">
      <div className="flex items-start space-x-3">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className={`mt-1 h-4 w-4 text-brand focus:ring-brand border ${
            error ? "border-state-danger" : "border-ui-border"
          } rounded`}
        />
        <label className="text-sm text-ui-text leading-5">
          {label} {required && <span className="text-state-danger">*</span>}
        </label>
      </div>
      {error && <p className="text-state-danger text-sm">{error}</p>}
    </div>
  );
};

export default CheckboxField;
